import faker from "@faker-js/faker";
import moment from "moment";
import { Drop } from "@src/core/models/drop";

export const mockDrop = (overrides?: Drop): Drop => ({
  createdAt: faker.date.past(),
  createdBy: faker.datatype.uuid(),
  creatorId: faker.datatype.uuid(),
  endsAt: moment().add(200, "seconds").toDate(),
  id: faker.datatype.uuid(),
  promotionDescription: faker.lorem.paragraph(),
  promotionHeadline: "This is a drop promotion headline",
  imageUrl: "https://gigaland.io/images/carousel/crs-5.jpg",
  startsAt: moment().add(10, "seconds").toDate(),
  updatedAt: faker.date.past(),
  updatedBy: faker.datatype.uuid(),
  ...(overrides || {}),
});
